// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","goTopBtn":"App_goTopBtn__RbIb4","icon":"App_icon__xc3AB"};